import Swal from "sweetalert2";
import {
  get_survey_file_input_file,
  should_process_survey_file,
} from "./survey_export_selectors";

function get_survey_answer_files(answer) {
  return Array.isArray(answer?.files) ? answer.files : [];
}

function get_first_survey_answer_file(answer) {
  const first_file = get_survey_answer_files(answer).find((item) => item?.file);

  return first_file?.file || null;
}

function show_survey_file_error(title, text) {
  Swal.fire({
    icon: "error",
    title,
    text,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    toast: true,
  });
}

function process_selected_survey_file(instance, question_id, file) {
  if (!instance.validate_survey_file(file)) {
    show_survey_file_error("Invalid File Type", "Only PDF and Word documents are allowed.");
    instance.clear_survey_file_answer(question_id);
    return;
  }

  instance.survey_answer_files = {
    ...instance.survey_answer_files,
    [question_id]: file,
  };
  instance.answers = {
    ...instance.answers,
    [question_id]: file.name,
  };
}

function process_survey_file_upload(instance, event, question) {
  const question_id = question?.question?.id;
  const selected_file = get_survey_file_input_file(event?.target?.files);

  if (!question_id) {
    return;
  }

  if (should_process_survey_file(selected_file)) {
    process_selected_survey_file(instance, question_id, selected_file);
    return;
  }

  show_survey_file_error("No File Selected", "Please select a file to upload.");
  instance.clear_survey_file_answer(question_id);

  if (event?.target) {
    event.target.value = "";
  }
}

export const survey_file_methods = {
  handle_survey_file_upload(event, question) {
    process_survey_file_upload(this, event, question);
  },
  validate_survey_file(file) {
    const allowed_extensions = [".pdf", ".doc", ".docx"];
    const file_name = String(file?.name || "").toLowerCase();

    return allowed_extensions.some((extension) => file_name.endsWith(extension));
  },
  clear_survey_file_answer(questionId) {
    const next_answers = { ...this.answers };
    const next_files = { ...this.survey_answer_files };

    Reflect.deleteProperty(next_answers, questionId);
    Reflect.deleteProperty(next_files, questionId);

    this.answers = next_answers;
    this.survey_answer_files = next_files;
  },
  get_survey_answer_file_url(answer) {
    const first_file = get_first_survey_answer_file(answer);
    return first_file?.s3_url || first_file?.file_url || first_file?.url || null;
  },
  get_survey_answer_file_name(answer) {
    const first_file = get_first_survey_answer_file(answer);
    return first_file?.name || answer?.answer || "View file";
  },
  view_survey_answer_file(answer) {
    const file_url = this.get_survey_answer_file_url(answer);

    if (!file_url) {
      this.show_error("No file was uploaded for this answer.");
      return;
    }

    window.open(file_url, "_blank", "noopener");
  },
};
